export default "__VITE_ASSET__DE92lMxV__"